document.addEventListener('DOMContentLoaded', function() {
  const feedbackBlocks = document.querySelectorAll('.feedback__text');

  feedbackBlocks.forEach(block => {
    const textContent = block.querySelector('.feedback__text-content');
    const button = block.querySelector('.feedback__toggle-btn');

    if (!textContent || !button) return;

    const collapsedHeight = 150;

    const updateHeights = () => {
      textContent.style.maxHeight = 'none'; // Убираем max-height, чтобы измерить реальную высоту
      const fullHeight = textContent.scrollHeight;

      if (fullHeight - collapsedHeight < 10) {
        // Если текст помещается, скрываем кнопку
        button.style.display = 'none';
        textContent.style.maxHeight = 'none';
      } else {
        textContent.style.maxHeight = collapsedHeight + 'px'; // Снова устанавливаем collapse
        button.addEventListener('click', () => {
          if (textContent.dataset.expanded === 'true') {
            textContent.style.maxHeight = collapsedHeight + 'px';
            textContent.dataset.expanded = 'false';
            button.textContent = 'Читать полностью';
          } else {
            const fullHeightExpanded = textContent.scrollHeight;
            textContent.style.maxHeight = fullHeightExpanded + 'px';
            textContent.dataset.expanded = 'true';
            button.textContent = 'Свернуть';
          }
        });
      }
    };

    updateHeights();
  });
});
(function () {
  function loadIframe(iframe) {
    if (!iframe || iframe.src) return;
    const src = iframe.getAttribute('data-src');
    if (src) {
      iframe.src = src;
      iframe.removeAttribute('data-src');
      iframe.classList.remove('js-lazy-iframe');
    }
  }

  const iframes = [].slice.call(document.querySelectorAll('.js-lazy-iframe[data-src]'));

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadIframe(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' }); // подгружаем заранее

    iframes.forEach(el => io.observe(el));
  } else {
    // Фолбэк: грузим после полной загрузки страницы
    window.addEventListener('load', () => iframes.forEach(loadIframe));
  }

    document.umnicoWidgetHash = 'd9ed4f4c8cd55673c4952b67c616a09f';
    var x = document.createElement('script');
    x.src = 'https://umnico.com/assets/widget-loader.js';
    x.type = 'text/javascript';
    x.charset = 'UTF-8';
    x.async = true;
    document.body.appendChild(x);
})();
